import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, Select } from "antd";
import Button from "../../Layout/DesignSystem/Button/Button";
import { Title } from "../../Utils/UI/Text";
import { getUsersSelector } from "../Infrastructure/Users.reducer";
import { getUsers, getUser } from "../Application/Users.business";

const { Option } = Select;

export default function Searcher() {
  const records = useSelector(getUsersSelector);

  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [selectedUserId, setSelectedUserId] = useState(null);

  const onFinish = async ({ id }) => {
    getUser(selectedUserId);
    navigate(`/users/${selectedUserId}`);
  };

  const onReset = () => {
    form.resetFields();
    setSelectedUserId(null);
  };
  const handleSelectChange = (value) => {
    setSelectedUserId(value);
  };

  function onSearch(val) {
    const params = {
      filter: { access_level: ["partner"] },
      page: 0,
      limit: 10,
      field_sort: "date",
      sort: "descending",
    };

    if (val) {
      params.q = val;
    }

    getUsers(params);
  }

  return (
    <>
      <Title children="Usuarios" />

      <Form
        layout="horizontal"
        form={form}
        onFinish={onFinish}
        onReset={onReset}
      >
        <div className="grid-searcher-user">
          <Select
            className="searcher-user-select"
            name="id"
            clearIcon
            showSearch
            onSearch={onSearch}
            placeholder="Selecciona un usuario"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={handleSelectChange}
          >
            {records?.map((record) => (
              <Option value={record.id} key={record.id}>
                {`${record.email} (${record.name} ${record.lastname})`}
              </Option>
            ))}
          </Select>

          <Button htmlType="submit" text={"Seleccionar"} />
        </div>
      </Form>
    </>
  );
}
